// Format display amounts without changing the value sent to the API.
export const CURRENCY_BY_LANGUAGE = {
  vi: { code: 'VND', symbol: '₫' },
  zh: { code: 'CNY', symbol: '¥' },
  en: { code: 'USD', symbol: '$' },
  th: { code: 'THB', symbol: '฿' },
  pt: { code: 'BRL', symbol: 'R$' },
  my: { code: 'MMK', symbol: 'K' },
};

export function getCurrencyByLanguage(language, fallback = 'vi') {
  const key = CURRENCY_BY_LANGUAGE[language] ? language : fallback;
  return CURRENCY_BY_LANGUAGE[key] || CURRENCY_BY_LANGUAGE.vi;
}

export function getCurrencySymbol(language, fallback = 'vi') {
  return getCurrencyByLanguage(language, fallback).symbol;
}

export function getCurrencyCode(language, fallback = 'vi') {
  return getCurrencyByLanguage(language, fallback).code;
}

export function formatVnd(value) {
  if (value === null || value === undefined || value === '') return '0';

  const numericValue = Number(String(value).replace(/,/g, '').trim());
  if (!Number.isFinite(numericValue)) return '0';

  const negative = numericValue < 0;
  const unsignedAmount = Math.abs(numericValue);
  const [integerRaw, fractionRaw = ''] = unsignedAmount.toFixed(2).split('.');
  const groupedInteger = integerRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const fractionPart = fractionRaw.replace(/0+$/, '');
  const isZero = unsignedAmount === 0;

  return (negative && !isZero ? '-' : '') + groupedInteger + (fractionPart ? '.' + fractionPart : '');
}



// WEBPACK FOOTER //
// ./src/utils/currency.js